function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    style: {
      fill: "#ee6f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 30H0c0 16.6 13.4 30 30 30s30-13.4 30-30",
    style: {
      fill: "#d15000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 29.7c-.2 0-.5-.1-.7-.2-.5-.2-.8-.7-.8-1.3V1.5C0 1 .3.4.8.2S2 0 2.4.3l18.5 13.3c.4.3.6.8.6 1.2 0 .5-.2 1-.6 1.2L2.4 29.4q-.3.3-.9.3",
    style: {
      fill: "#f4f7f9"
    },
    transform: "translate(21.429 15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 14.9v13.3c0 .6.3 1.1.8 1.4.2.1.5.2.7.2q.45 0 .9-.3l18.5-13.3c.4-.3.6-.8.6-1.2H0z",
    style: {
      fill: "#cfd6da"
    },
    transform: "translate(21.429 15)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnPlay);
export default __webpack_public_path__ + "static/media/btnPlay.7d2edec1cf6b7cef5935af7276fa7c3c.svg";
export { ForwardRef as ReactComponent };